import { apiClient } from "./apiClient";
import { log } from "./log";

interface TrackTelemetryParams {
  name: string;
  extra?: object;
}

/**
 * Track a telemetry event to PostgreSQL.
 * This is a fire-and-forget operation - errors are logged but not thrown.
 */
export function trackTelemetryInPostgres(params: TrackTelemetryParams): void {
  // Fire and forget - don't await
  apiClient
    .post<{ success: boolean; id?: string }>("/telemetry/log", params)
    .then((response) => {
      log.debug(`[telemetry] Event logged: ${params.name}`, response.id);
    })
    .catch((error) => {
      // Silently log errors - telemetry should never break the app
      log.debug(`[telemetry] Failed to log event: ${params.name}`, error);
    });
}
